import classNames from 'classnames';

import styles from './_index.module.scss';

export interface FlexProps extends React.HTMLAttributes<HTMLElement> {
  direction?: 'column' | 'column-reverse' | 'row' | 'row-reverse';
  // eslint-disable-next-line perfectionist/sort-union-types
  gap?: 'none' | 'x-small' | 'small' | 'medium' | 'large' | 'x-large';
}

const Flex = <T extends React.ElementType>({
  as,
  className,
  direction = 'row',
  gap = 'medium',
  ...props
}: FlexProps & PolymorphicProps<T>) => {
  const Component = as || 'div';
  return (
    <Component
      className={classNames(styles[`flex-${direction}`], styles[`is-${gap}`], className)}
      {...props}
    />
  );
};

const FlexColumn = <T extends React.ElementType>(
  args: Omit<FlexProps, 'direction'> & PolymorphicProps<T>
) => <Flex direction="column" {...args} />;

const FlexRow = <T extends React.ElementType>(
  args: Omit<FlexProps, 'direction'> & PolymorphicProps<T>
) => <Flex direction="row" {...args} />;

export default Object.assign(Flex, {
  Column: FlexColumn,
  Row: FlexRow,
});
